import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { ProductLinesComponent } from './product-lines';
import { ModelsComponent } from './model-component';
import { QuoteApprovalsComponent } from './quote-approvals';
import { CustomerInfoComponent } from './customer-info';
import { OptionsConfigurationComponent } from './options-configuration';
import { OptionsAdminComponent } from './options-admin';
import { SetMarkupComponent } from './set-markup';
import { OrderInformationComponent } from './order-information';
import { QuoteSummaryComponent } from './quote-summary';
import { QuoteCompareComponent } from './quote-compare/quote-compare.component';
import { OptionComponent } from './option-component';
import { AuditHistoryComponent } from './audit-history';
import { DeactivateFormGuard } from './reusable-components/route-control/deactivate-form.guard';
import { TruExpComponent } from './truexp';

const routes: Routes = [
   { path: 'truexp', component: TruExpComponent },
  { path: ':quoteId', component: CustomerInfoComponent }, 
  {
    path: 'choose-product-line/:quoteId',
    component: ProductLinesComponent,
    canDeactivate: [DeactivateFormGuard]
  },
  {
    path: 'customer-info/:userId/:retailerNumber/:quoteId',
    component: CustomerInfoComponent,
    canDeactivate: [DeactivateFormGuard]
  },
  {
    path: 'choose-product-line/:quoteId',
    component: ProductLinesComponent,
    canDeactivate: [DeactivateFormGuard]
  },
  {
      path: 'customer-info', 
      component: CustomerInfoComponent,
      canDeactivate: [DeactivateFormGuard]
  },
  {
    path: 'customer-info/:quoteId',
    component: CustomerInfoComponent,
    canDeactivate: [DeactivateFormGuard]
  },
  {
    path: 'choose-model/:quoteId',
    component: ModelsComponent,
    canDeactivate: [DeactivateFormGuard]
  },
  {
    path: 'options-configuration/:quoteId',
    component: OptionsConfigurationComponent,
    children: [
      {
        path: '',
        component: OptionComponent
      }
    ],
    canDeactivate: [DeactivateFormGuard]
  },
  {
    path: 'set-markup/:quoteId',
    component: SetMarkupComponent,
    canDeactivate: [DeactivateFormGuard]
  },
  {
    path: 'order-information/:quoteId',
    component: OrderInformationComponent,
    canDeactivate: [DeactivateFormGuard]
    },
  { path: ':quoteId', component: CustomerInfoComponent },
  { path: 'quote-summary/:quoteId/:userId', component: QuoteSummaryComponent },
  { path: 'quote-summary/:quoteId', component: QuoteSummaryComponent },
  { path: 'quote-compare/:quoteId', component: QuoteCompareComponent },
  { path: 'options-admin/:userId', component: OptionsAdminComponent },
  { path: 'quote-history/:quoteId', component: AuditHistoryComponent },
  { path: 'quote-approvals/:userId', component: QuoteApprovalsComponent }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.routing.ts